module.exports = "pegasus/assets/square-facebook.gif";